module.exports = __webpack_public_path__ + "static/media/GW.4c326498.svg";